export default "__VITE_ASSET__hG4y4kNI__"